import automation from "./assests/images/Vector-1.png";
import development from "./assests/images/Vector-2.png";
import enterprise from "./assests/images/Vector-3.png";
import analytics from "./assests/images/analytics.webp";
import cloud from "./assests/images/cloud.webp";
import support from "./assests/images/support.png";
import implementation from "./assests/images/implementation.jpg";
import project from "./assests/images/projectScope.jpg";
import handshakeImg from "./assests/images/hire-talent.webp";
import efficiencyImg from "./assests/images/implementation.webp";
import qualityImg from "./assests/images/project-scope.webp";
import speakingImg from "./assests/images/applyjob.webp";
import teamImg from "./assests/images/consult-landing.webp";
import skillsImg from "./assests/images/analytics.webp";
import reliableImg from "./assests/images/cloud.webp";
import timerImg from "./assests/images/support.webp";
import videoCallImg from "./assests/images/what-is-hr.webp";
import youngCoupleImg from "./assests/images/cloudare.webp";
import paymentImg from "./assests/images/Comply.webp";
import taxRefundImg from "./assests/images/Einv.jpg";
import accountingImg from "./assests/images/ERP1.jpg";
import stockMarketImg from "./assests/images/Group 117.webp";
import einvoiceImg from "./assests/images/Benefits_of_E_invoicing.jpg";
import invoiceBillImg from "./assests/images/HR-Consulting.png";
import customerImg from "./assests/images/GotAProject.jpg";
import deskTopImg from "./assests/images/jaggaer.webp";
import creditCardImg from "./assests/images/mensa.webp";
import meetingImg from "./assests/images/CloudareForEinvCard.jpg";


import bhyssyen from "./assests/logo/BHYSSYEN.png";
import bohiyaanam from "./assests/logo/bohiyaanam.png";
import codex from "./assests/logo/codex.png";
import fime from "./assests/logo/Fime.png";
import newj from "./assests/logo/newj.jpg";
import occamonics from "./assests/logo/Occamonics.png";
import rostan from "./assests/logo/ROSTAN.webp";
import slp from "./assests/logo/SLPMicrosystems.png";
import smart from "./assests/logo/smart.jfif";
// import ifa from "./assests/logo/ifa.png";
// import penta from "./assests/logo/penta.jfif";
// import path from "./assests/logo/path.jfif";
import techgeminus from "./assests/logo/teckgeminus.png";

//Partner logo
import iris from "./assests/logo/iris.jpg";
// import alankit from "./assests/logo/Alankit-Healthcare.png";
import cygnet from "./assests/logo/cygnet-group1.png";
import masterindia from "./assests/logo/masters-india.png";
import cleartax from "./assests/logo/cleartax-logo.jpg";
import ey from "./assests/logo/ey01.png";
import zoho from "./assests/logo/zoho.png";
import oracle from "./assests/logo/Oracle.svg";
import razorpay from "./assests/logo/razorpay.svg";

import odoo from "./assests/logo/odoo.png";
import ecosi from "./assests/logo/ecosi.png";
import Hostbook from "./assests/logo/Hostbook.png";
import BDO_india from "./assests/logo/BDO_india.png";
import complyance from "./assests/logo/complyance.png";
import alvarezmarsal from "./assests/logo/Alvarez-Marsal.png";
import mastek from "./assests/logo/mastek.png";
// import thinkperfect from "./assests/logo/thinkperfect2.png";

//client logo
import mindzie from "./assests/logo/mindzie.webp";
import clearskype from "./assests/logo/clearskye.png";
import craftsman from "./assests/logo/craftsman-logo.png";
import navi from "./assests/logo/navi.png";
import mensa from "./assests/logo/mensa.PNG";
import villian from "./assests/logo/villian.jpg";
import helea from "./assests/logo/helea.png";
import priyaasi from "./assests/logo/priyaasi.jpg";
import bagedo from "./assests/logo/Bagedo.jpg";
import fibe from "./assests/logo/fibe.jpg";
// import apl from "./assests/logo/apl.jpg";
import airtel from "./assests/logo/Bharti_Airtel.webp";
import cloudnine from "./assests/logo/cloud-nine.webp";
import crisil from "./assests/logo/crisil.png";
import iffco from "./assests/logo/iffco.png";
import ihcl from "./assests/logo/ihcl.jpg";
import implexian from "./assests/logo/implexian.jpg";
import omaxe from "./assests/logo/omaxe.webp";
import sbi from "./assests/logo/sbi.jpg";
import virtusa from "./assests/logo/virtusa.png";
import tvs from "./assests/logo/tvs.jpg";
import tata from "./assests/logo/tata.avif";
// import firstamerica from "./assests/logo/firstamerica.jpg";
// import ace from "./assests/logo/ace.png";
// import bgppl from "./assests/logo/bgppl.jpeg";
// import bilt from "./assests/logo/bilt.png";
import lcgc from "./assests/logo/lcgc.jpg";
import motherson from "./assests/logo/Motherson.jpg";
// import patrick from "./assests/logo/patrick.png";
import portescap from "./assests/logo/portescap.png";
import rychem from "./assests/logo/raychem.png";
import religare from "./assests/logo/Religare.jpg";
import seertree from "./assests/logo/seertree.jpg";
import tpi from "./assests/logo/tpi.png";


import cleartrip from "./assests/logo/cleartrip.png";
import kiMobility from "./assests/logo/ki-mobility.png";
import dorfKetal from "./assests/logo/dorf-ketal.png";
import curefoods from "./assests/logo/curefoods.png";
import nextiva from "./assests/logo/nextiva.png";
import wiproPari from "./assests/logo/wipro-pari.png";

// Malaysia Clients
import bolttech from "./assests/logo/my_logos/bolttech-Logo.jpg";
import graneeMarketing from "./assests/logo/my_logos/granee-marketing.jpg";
import isuzu from "./assests/logo/my_logos/Isuzu.png";
import gamuda from "./assests/logo/my_logos/gamuda.png";


//Staffing/Clients
import vaidyas from "./assests/logo/DrVaidyas.webp";
import tablespace from "./assests/logo/tablespace.png";
import rapidflow from "./assests/logo/rapidflow.png";
import eSoft from "./assests/logo/eSoft.svg";
import tatasteel from "./assests/logo/tata-steel.jpg";
import modicare from "./assests/logo/modicare.jpg";
import t24seven from "./assests/logo/t24seven.jpg";
import supersourcing from "./assests/logo/supersourcing.png";
import motilaloswal from "./assests/logo/motilaloswal.png";
import rightpointindia from "./assests/logo/Rightpoint-India.svg";
import majorel from "./assests/logo/majorel.png";
import shyamsteelindia from "./assests/logo/Shyam-Steel-India.jpg";
import Datamatics from "./assests/logo/Datamatics.png";
import paytm from "./assests/logo/paytm.jpg";
import chanakyaforum from "./assests/logo/Chanakya-Forum.png";
import Devstringx from "./assests/logo/Devstringx.png";
import Mitsogo from "./assests/logo/Mitsogo.jpg";
import SATechnologies from "./assests/logo/SA-Technologies.png";
import CloudThat from "./assests/logo/CloudThat.png";
import Wissen from "./assests/logo/Wissen.png";
import ECCouncil from "./assests/logo/EC-Council.jpg";
import hcl from "./assests/logo/hcl.jpg";
import lenskart from "./assests/logo/lenskart.png";

//Staffing Clients
export const CLIENTS = [
  Mitsogo,
  SATechnologies,
  CloudThat,
  Wissen,
  ECCouncil,
  hcl,
  lenskart,
  shyamsteelindia,
  Datamatics,
  paytm,
  chanakyaforum,
  Devstringx,
  ey,
  vaidyas,
  tablespace,
  rapidflow,
  eSoft,
  tatasteel,
  modicare,
  t24seven,
  supersourcing,
  motilaloswal,
  rightpointindia,
  majorel,
];
export const DEV = [
  ey,
  cleartax,
  codex,
  navi,
  craftsman,
  techgeminus,
  occamonics,
  mindzie,
  masterindia,
];
export const PARTNERS = [
  oracle,
  razorpay,
  ey,
  fime,
  newj,
  vaidyas,
  eSoft,
  mindzie,
  bhyssyen,
  bohiyaanam,
  codex,
  occamonics,
  rapidflow,
  rostan,
  slp,
  tablespace,
  smart,
];
//Enterprises and startups use Cloudare as SI partner
export const PRODUCT_FIRST_SLIDER = [
  ecosi,

  oracle,
  cleartax,
  razorpay,
  odoo,
  ecosi,
  Hostbook,
  ey,
  iris,
  cygnet,
  Hostbook,
  // alankit,
  zoho,
  odoo,
  ey,
  masterindia,
  // iris,

  Hostbook,
  // iris,
  // alankit,
  cygnet,
  complyance,
  BDO_india,
  mastek,
  oracle,
  zoho,
  razorpay,
  masterindia,
  alvarezmarsal,
  // thinkperfect,
  ey,
];
// Our Clients
export const PRODUCT_SECOND_SLIDER = [
  tvs,
  fime,
  bagedo,
  craftsman,
  lcgc,
  kiMobility,
  navi,
  motherson,
  cleartrip,
  wiproPari,
  dorfKetal,
  rychem,
  curefoods,
  portescap,
  religare,
  mindzie,
  seertree,
  nextiva,

  tpi,
  tata,
  airtel,
  cloudnine,
  crisil,
  iffco,
  ihcl,
  omaxe,
  sbi,
  virtusa,
  mensa,
  villian,
  priyaasi,
  helea,
  implexian,
  fibe,
  tablespace,
  clearskype,
];

// Malaysia Clients
export const Malaysia_Clients_SLIDER = [
  graneeMarketing,
  isuzu,
  bolttech,
  gamuda,
];

export const SERVICES = [
  {
    title: "High quality, sensible cost",
    content: [
      {
        subtitle: "Hire Silicon Valley caliber at half the cost",
        content:
          "Access rigorously screened engineers and consultants — the kind of talent global product teams rely on, without global-headcount pricing.",
      },
      {
        subtitle: "Broad skill coverage",
        content:
          "React, Node, Python, Angular, Swift, React Native, Android, Java, Rails, Golang, DevOps, ML and Data Engineering — plus Oracle, SAP and e-invoicing specialists.",
      },
      {
        subtitle: "Low-risk start",
        content:
          "Begin with a short trial window — if it isn't the right fit in the first two weeks, you don't pay for that engagement.",
      },
    ],
  },
  {
    title: "Rigorous vetting",
    content: [
      {
        subtitle: "Multi-stage technical assessment",
        content:
          "Every candidate goes through several hours of structured tests and interviews covering data structures, algorithms, system design and their core specialization.",
      },
      {
        subtitle: "Role-matched screening",
        content:
          "We assess against the specific stack and seniority you need, so shortlisted profiles are genuinely relevant rather than generic.",
      },
      {
        subtitle: "Ownership and communication",
        content:
          "We select strong communicators who can proactively take ownership of business and product objectives without needing micromanagement.",
      },
    ],
  },
  {
    title: "Flexible engagement models",
    content: [
      {
        subtitle: "Contract, contract-to-hire or permanent",
        content:
          "Scale a team up or down with C2C and W2 options across India, the UAE, KSA, the US and the UK — whatever your project and compliance needs require.",
      },
      {
        subtitle: "RPO and managed teams",
        content:
          "Hand off recruitment end to end, or stand up a managed pod that delivers under your direction with Cloudare handling the operations.",
      },
      {
        subtitle: "Fast ramp-up",
        content:
          "Pre-screened talent pools mean we can shortlist quickly and get the right people onto your project without a long lead time.",
      },
    ],
  },
];
// Reviews/testimonials. Currently empty — the About-page ratings section that
// consumed this is disabled. Populate with real, permissioned testimonials
// before re-enabling that section. (No placeholder/lorem content.)
export const REVIEWS = [];
export const PRIVACY = [
  {
    title: "What do we do with your information?",
    content: [
      `When you contact us, request a proposal, or engage our services, we collect the personal information you provide, such as your name, business email, phone number and company details.`,
      `When you browse our website, we also automatically receive your device's internet protocol (IP) address, which helps us understand your browser and operating system and improve our site.`,
      `Email communications (if applicable): with your permission, we may send you updates about our services, mandates and other relevant information.`,
    ],
  },
  {
    title: "Consent",
    content: [
      `When you provide us with personal information to complete an engagement, process a payment, or otherwise transact with us, we take it that you consent to our collecting it and using it for that specific reason only.`,
      `If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no.`,
      `If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us at hello@cloudare.in`,
    ],
  },
  {
    title: "Disclosure",
    content: [
      "We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.",
    ],
  },
  {
    title: "Payment",
    content: [
      `We use Razorpay for processing payments.We/Razorpay do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved.`,
      `Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover.`,
      `PCI-DSS requirements help ensure the secure handling of credit card information by us and our service providers.`,
      `For more insight, you may also want to read terms and conditions of Razorpay on https://razorpay.com`,
    ],
  },
  {
    title: "Security",
    content: [
      "To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed",
    ],
  },
  {
    title: "Cookies",
    content: [
      "We use cookies to maintain session of your user. It is not used to personally identify you on other websites.",
    ],
  },
  {
    title: "Age Of Consent",
    content: [
      "By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.",
    ],
  },
  {
    title: "Your Rights & Applicable Data Protection Laws",
    content: [
      "Cloudare operates across multiple jurisdictions. Depending on where you are located, you may have rights under laws such as India's Digital Personal Data Protection Act, 2023 (DPDP Act), the EU/UK General Data Protection Regulation (GDPR), the UAE Personal Data Protection Law (PDPL), and the Saudi Arabia Personal Data Protection Law (PDPL).",
      "Subject to applicable law, you have the right to access the personal data we hold about you, request correction of inaccurate data, request deletion, withdraw consent, object to or restrict certain processing, and request portability of your data.",
      "Where we rely on consent (for example, marketing communications or non-essential cookies), you may withdraw that consent at any time. Withdrawing consent does not affect the lawfulness of processing carried out before withdrawal.",
      "To exercise any of these rights, contact us at hello@cloudare.in. We will respond within the timelines required by applicable law.",
    ],
  },
  {
    title: "International Data Transfers",
    content: [
      "Because Cloudare has offices and service providers in India, the UAE, the United States and Canada, your personal data may be transferred to and processed in countries other than your own. Where required, we put in place appropriate safeguards for such transfers in line with applicable data protection laws.",
    ],
  },
  {
    title: "Data Retention",
    content: [
      "We retain personal data only for as long as necessary to fulfil the purposes for which it was collected, including to satisfy legal, accounting, or reporting requirements. When data is no longer required, we securely delete or anonymise it.",
    ],
  },
  {
    title: "Grievance / Data Protection Officer",
    content: [
      "For any privacy-related questions, requests, or complaints, you may contact our Grievance Officer / Data Protection contact at hello@cloudare.in. We take all such requests seriously and will work with you to resolve any concerns.",
    ],
  },
  {
    title: "Changes to this Privacy Policy",
    content: [
      `We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.`,
      `If Cloudare is acquired by or merged with another company, your information may be transferred to the new owners so that we can continue to provide services to you.`,
    ],
  },
  {
    title: "QUESTIONS AND CONTACT INFORMATION",
    content: [
      "If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at hello@cloudare.in",
    ],
  },
];
export const SERVICES_OPTION = [
  {
    src: analytics,
    service: "Analytics",
    desc: "Access actionable data insights for meaningful collaboration. Enhance customer experiences for better business outcomes",
  },
  {
    src: automation,
    service: "Automation",
    desc: "Automate repetitive tasks to simplify processes, drive operational efficiency, and increase employee productivity",
  },
  {
    src: cloud,
    service: "Cloud services",
    desc: "Accelerate to cloud with confidence. Achieve high availability, improved performance, security, and optimized costs.",
  },
  {
    src: development,
    service: "App Development",
    desc: "Possess virtually any feature that your business requires or desires, and improve performance through innovative applications",
  },
  {
    src: enterprise,
    service: "Enterprise Applications",
    desc: "Universal integration for real time cross functions. Greater agility, cost savings, and increased efficiency",
  },
];

export const CONSULT_SERVICES = [
  {
    src: project,
    content: [
      {
        subtitle: "Project Scope (Gap Analysis)",
        content:
          "Every project starts with thorough research and clear scope definition, so the engagement stays efficient and free of unwanted delays.",
      },
    ],
  },
  {
    src: implementation,
    content: [
      {
        subtitle: "Implementation",
        content:
          "Our certified consultants deliver structured implementation with defined milestones, clean configuration, and rigorous testing before go-live.",
      },
    ],
  },
  {
    src: support,
    content: [
      {
        subtitle: "Support",
        content:
          "Post go-live, our team provides ongoing AMS, enhancements, and responsive support so your systems keep running smoothly.",
      },
    ],
  },
];
export const WHY_US = [
  {
    title: "Hire with confidence",
    src: handshakeImg,
    desc: "If you are not happy with the profiles, you pay nothing",
  },
  {
    title: "High quality/cost ratio",
    src: efficiencyImg,
    desc: "High caliber talent at 8-12.5% of the CTC",
  },
  {
    title: "Get full transparency",
    src: qualityImg,
    desc: "View work history, portfolios and more",
  },
  {
    title: "Fluent English Speakers",
    src: speakingImg,
    desc: "Excellent communicators who take ownership of business and product objectives",
  },
  {
    title: "Ensure quick turnarounds",
    src: teamImg,
    desc: "Get matched with highly compatible talent within 2 days",
  },
  {
    title: "100+ skills available",
    src: skillsImg,
    desc: "Hire IT skills like Oracle, SAP, React, Node, Python, Angular, Swift, React Native, Android, Java, DevOps, ML, and Non-IT like Sales, PMO etc.",
  },
];
export const BENEFITS = [
  { title: "Talent Quality", desc: "Top 3%" },
  { title: "Prevetted Talent ", desc: "Yes" },
  { title: "Incentive Alignment", desc: "Yes" },
  { title: "Quality Guarantee", desc: "Yes" },
];
export const FAQs = [
  {
    id: 1,
    ques: "How long does it take to hire resources?",
    ans: "The answer varies widely by type of position. Usually, the more entry-level, the quicker, while the more senior, technical, or executive, the longer it takes.\n Entry-level roles with no prerequisites might take a couple of weeks, on average, while management roles could take several months—or longer.\nWe have a solution for this! With a team having expertise in several domains in recruitment, we can get the entire process completed within 15 – 20 days.",
  },
  {
    id: 2,
    ques: "Who takes responsibility for managing the employee?",
    ans: "Once we deploy a candidate to a client, the candidate will be the whole sole responsibility of the client. Cloudare stands nowhere in between the client & the candidate for resolving issues related to attendance, performance, etc.",
  },
  {
    id: 3,
    ques: "Can you provide the same resource on contract basis too?",
    ans: "Yes, we can provide the same resource. However, the budget will be different which we can be discussed.",
  },
  {
    id: 4,
    ques: "How does the payment cycle work?",
    ans: "The payment cycle will be NET 30 days after the candidate successfully joins the client. However, this can be altered from case to case basis.",
  },
  {
    id: 5,
    ques: "What if our CTC percentage budget is less?",
    ans: "Here also, you don’t have to worry. We have experts working with us who can ideally get candidates within your budget. \n You can rely on us!",
  },
  {
    id: 6,
    ques: "What if none of the resources are shortlisted by our Hiring team?",
    ans: "The answer is: we have never faced such issues, as our team works in such a fantastic manner, that within two slots of profiles, even your niche profile will get closed.",
  },
];
export const CLIENTS_TESTIMONIALS = [
  {
    content:
      "It’s a pleasure to work with the Cloudare Technologies team through this phase of talent hunting. They are remarkably productive throughout the process, carefully managed my specifications and priorities & professional enough in picking the suitable talent, was ideal for what I was looking for.",
    rname: "Kirti Raghuvanshi",
    rtitle: "HR Manager",
  },
  {
    content:
      "I have worked with Cloudare Technologies on several candidate recruitments now and have found them to be competent and professional recruitment consultants. They have been excellent support for our business and have been very successful in finding us the excellent candidates we require. ",
    rtitle: "HR Manager",
    rname: "Megha Kapoor",
  },
  {
    content:
      "Cloudare always working to make client satisfaction in deliverables. It has a wide range of plan strategy to have resource's from different parts of the world to improve the services every single day. Eventually I was part of Cloudare, And I'm so happy and prveilage to  work for one of the best businesses you have. I'm eagerly looking forward go get associated with Cloudare soon in near future.",
    rname: "Sindhu Matta",
    rtitle: "Oracle HCM Consultant",
  },
];
export const DEVELOPERS_TESTIMONIALS = [
  {
    content:
      "It’s a pleasure to be a part of Cloudare Technologies. There is no pressure from the management and equal opportunity are provided for all. Work life balance is quite good.",
    rname: "Aakanksha Agrawal",
    rtitle: "Developer",
  },
  {
    content:
      "It’s a pleasure to be a part of Cloudare Technologies. Good work culture , good work life balance, management is polite ,value the employee's work. Higher management is reachable.",
    rname: "Sindhu",
    rtitle: "Developer",
  },
  {
    content:
      "I appreciate our organization's positive work-life balance and pressure-free environment. The focus on being people-oriented and learning and growing together enhances our professional development.",
    rname: "Sneha Vinaykumar",
    rtitle: "HR BP",
  },

  {
    content:
      "The company offers valuable opportunities for freshers, fostering a culture of continuous learning. I am grateful for the support from both co-workers and seniors, which significantly contributes to my professional growth.",
    rname: "Aman Sharma",
    rtitle: "Software Engineer",
  },

  {
    content:
      "The company supports women balancing home and family responsibilities, promoting understanding and collaboration while providing valuable learning opportunities.",
    rname: "Nithya Prakash",
    rtitle: "COO",
  },

  {
    content:
      "Working at Cloudare Technologies has been an incredible journey. The team fosters a collaborative environment where innovation thrives. Work-life balance is prioritized, and the management is always approachable.",
    rname: "Rahul Sharma",
    rtitle: "Senior Developer",
  },

  {
    content:
      "Cloudare Technologies truly values its employees. The learning opportunities here are endless, and the leadership is supportive. It's amazing to work in such a dynamic and inclusive workspace.",
    rname: "Priya Verma",
    rtitle: "Software Engineer",
  },

  {
    content:
      "The culture at Cloudare Technologies is inspiring. There’s always room to grow, and the company invests in its people. I feel valued and motivated every day!",
    rname: "Amit Patel",
    rtitle: "Tech Lead",
  },

  {
    content:
      "A great place to work! The projects are challenging yet rewarding, and the entire team is super supportive. I’ve grown tremendously in my role.",
    rname: "Neha Kapoor",
    rtitle: "UI/UX Designer",
  },
];
export const WHY_CLOUDARE = [
  {
    title: "Reliable Jobs",
    src: reliableImg,
    desc: "We only work with trusted, vetted companies",
  },
  {
    title: "Always get paid on time",
    src: timerImg,
    desc: "Never face any delays on pay outs",
  },
  {
    title: "Fully Supported",
    src: videoCallImg,
    desc: "Whereever you are and whatever issues you may face, we’re here to help solve any challenges, fast!",
  },
  {
    title: "Get Expertly Matched",
    src: youngCoupleImg,
    desc: "Our experts will match you to jobs based on your skill sets, alignment, and interest.",
  },
];

export const PRODUCTS_OPTION = [
  {
    cardNumber: "FIRST",
    src: paymentImg,
    product: "Vendor Payment blocking based on 2A/2B",
    desc: "Vendor Payment Blocking refers to a system implemented by organizations to ensure compliance with regulatory requirements and prevent unauthorized or fraudulent payments to vendors. It involves a thorough review and verification process before releasing payments to vendors or suppliers.",
  },
  {
    cardNumber: "SECOND",
    src: taxRefundImg,
    product: "GST Sales and Purchase Integration",
    desc: "GST sales and purchase integration refers to the process of automating and linking your sales and purchase data with the GST system. It involves integrating your business's financial software or enterprise resource planning (ERP) system with the GST portal to ensure accurate and real-time reporting of GST transactions.",
  },
  {
    cardNumber: "THIRD",
    src: accountingImg,
    product: "E-Invoicing/ EWB Generation",
    desc: "Welcome to our website! We provide seamless integration solutions for e-invoicing and e-way bill (EWB) generation, streamlining your business processes and improving efficiency. With our advanced technology and expertise, we ensure a hassle-free experience for managing your invoices and generating EWBs. Here's how our integration can benefit your organization",
  },
  {
    cardNumber: "FOURTH",
    src: stockMarketImg,
    product: "TDS Data Integration",
    desc: "We are a leading provider of comprehensive data integration solutions, specializing in helping businesses streamline their data management processes. Our innovative technologies and expertise enable organizations to seamlessly connect and integrate data from diverse sources, empowering them to make informed decisions, drive operational efficiency, and achieve business success.",
  },
  {
    cardNumber: "FIFTH",
    src: einvoiceImg,
    product: "ZATCA E-Invoicing",
    desc: "ZATCA E-Invoicing is a cutting-edge platform that revolutionizes the way businesses handle their invoicing processes.Our robust electronic invoicing solutionstreamlines the invoicing workflow, reduces manual errors, and enhances overall efficiency.With ZATCA E- Invoicing, you can enjoy seamless and secure electronic invoicing that saves you time and resources.",
  },

  {
    cardNumber: "SIXTH",
    src: invoiceBillImg,
    product: "MALAYSIA E-Invoicing",
    desc: "Malaysia E-Invoicing is an innovative platform designed to transform how businesses manage their invoicing processes. Our comprehensive electronic invoicing solution simplifies the workflow, minimizes manual errors, and boosts overall efficiency. With Malaysia E-Invoicing, you can experience smooth and secure invoicing that helps you save time and resources, ensuring a streamlined and reliable approach to your business needs.",
  },
];

export const PAYROLL_OPTION = [
  {
    src: customerImg,
    payroll: "Payroll Processing",
    desc: "Payroll processing includes the generation of paychecks or direct deposits, submission of tax withholdings to government authorities, and the preparation of payroll reports for record-keeping and compliance purposes. It also ensures that employees are paid accurately and on time while complying with legal and regulatory requirements related to taxes, benefits, and labor laws.",
  },
  {
    src: deskTopImg,
    payroll: "Tax Management",
    desc: "Say goodbye to the headache of managing payroll taxes. We take care of all tax calculations, including federal, state, and local taxes. We also handle tax filings and reporting to ensure compliance with all relevant regulations.",
  },
  {
    src: creditCardImg,
    payroll: "Direct Deposit",
    desc: "Simplify the payment process by offering direct deposit to your employees. Our system securely transfers funds directly into their bank accounts, eliminating the need for paper checks and reducing administrative costs.",
  },
  {
    src: meetingImg,
    payroll: "Employee Self-Service",
    desc: "Empower your employees with our user-friendly self-service portal. They can access their pay stubs, tax forms, and other relevant documents online, reducing the need for manual distribution and improving overall efficiency.",
  },
  {
    src: handshakeImg,
    payroll: "Customized Reporting",
    desc: "Gain valuable insights into your payroll data with our customized reporting feature. We provide detailed reports on employee earnings, tax liabilities, and more, enabling you to make informed decisions and track key payroll metrics.",
  },
  {
    src: efficiencyImg,
    payroll: "Compliance and Security",
    desc: "We prioritize the security and confidentiality of your payroll data. Our system employs the latest encryption technologies and follows strict industry standards to safeguard your sensitive information. Additionally, we stay up to date with changing regulations to ensure compliance with all applicable laws.",
  },
  {
    src: qualityImg,
    payroll: "Background Verification",
    desc: "Background verification check, is a process used by employers, organizations, or individuals to verify the accuracy of an individual's personal, educational, and professional history. The purpose of conducting a background check is to ensure that the person being screened is trustworthy, reliable, and suitable for the position or task at hand.",
  },
];

export const PAYROLL_BANNERS = [
  {
    rname: "Accuracy and Reliability",
    content:
      "We have a proven track record of delivering accurate and reliable payroll services. With our expertise, you can have peace of mind knowing that your payroll will be processed flawlessly.",
  },
  {
    rname: "Time and Cost Savings",
    content:
      "Outsourcing your payroll tasks to us allows you to focus on your core business activities. By eliminating the need for in-house payroll management, you can save time and reduce operational costs.",
  },
  {
    rname: "Scalability",
    content:
      "Whether you have a small team or a large workforce, our payroll service is designed to scale with your business. As your organization grows, we can accommodate your changing needs and ensure seamless payroll operations.",
  },
  {
    rname: "Dedicated Support",
    content:
      "Our friendly and knowledgeable support team is always ready to assist you. We provide prompt responses to your inquiries and offer ongoing support to address any payroll-related questions or concerns.",
  },
  {
    rname: "Integration Options",
    content:
      "We understand that payroll is just one piece of the puzzle. Our service can integrate seamlessly with other HR and accounting software, allowing for efficient data transfer and synchronization.",
  },
];

export const INDIA_FINANCE = [
  {
    title: "Proven expertise & industry experience",
    art: "expertise",
    desc: "Strong track record across industries with the ability to align ERP solutions to specific business needs.",
  },
  {
    title: "Client success & case studies",
    art: "casestudy",
    desc: "Demonstrated success through real implementations, measurable outcomes, and credible client references.",
  },
  {
    title: "Scalability & future readiness",
    art: "scalability",
    desc: "ERP solutions designed to support business growth, flexibility, and evolving technology integrations.",
  },
  {
    title: "Structured project execution",
    art: "execution",
    desc: "Defined methodologies, clear milestones, and risk-controlled delivery ensure smooth implementation.",
  },
  {
    title: "Change management & user adoption",
    art: "adoption",
    desc: "Effective training and change management practices that drive seamless adoption and maximize ROI.",
  },
  {
    title: "Reliable support & strong partnerships",
    art: "support",
    desc: "Ongoing support, certifications, and vendor partnerships ensuring long-term performance and stability.",
  },
];

export const MIDDLE_EAST_FINANCE = [
  {
    content:
      "It’s a pleasure to work with the Cloudare Technologies team through this phase of talent hunting. They are remarkably productive throughout the process, carefully managed my specifications and priorities & professional enough in picking the suitable talent, was ideal for what I was looking for.",
    rname: "Kirti Raghuvanshi",
    rtitle: "HR Manager",
  },
  {
    content:
      "I have worked with Cloudare Technologies on several candidate recruitments now and have found them to be competent and professional recruitment consultants. They have been excellent support for our business and have been very successful in finding us the excellent candidates we require. ",
    rtitle: "HR Manager",
    rname: "Megha Kapoor",
  },
  {
    content:
      "Cloudare always working to make client satisfaction in deliverables. It has a wide range of plan strategy to have resource's from different parts of the world to improve the services every single day. Eventually I was part of Cloudare, And I'm so happy and prveilage to  work for one of the best businesses you have. I'm eagerly looking forward go get associated with Cloudare soon in near future.",
    rname: "Sindhu Matta",
    rtitle: "Oracle HCM Consultant",
  },
];
